import type { PalletSummary } from "@/api/order_check";
import { groupSscc } from "@/lib/boxes";

/** Номер паллеты для человека — тот, что на её этикетке.
 *
 *  Своя паллета — грузоместо реестра (этап 3а): наш SSCC, группами по четыре,
 *  как у всех SSCC портала (`groupSscc`). Плановая (план из 1С) — номер
 *  документа 1С, как прежде. Нет ни того, ни другого — null. */
export function palletNumber(p: Pick<PalletSummary, "sscc" | "one_c_number">): string | null {
  if (p.sscc) return groupSscc(p.sscc);
  return p.one_c_number ?? null;
}
